<template>
  <div>
    <div class="py-4">
      <div class="year mb-2">
        {{ year }}
      </div>
      <div class="weekly">
        {{ $t("calendar.weekly") }}
      </div>
    </div>
    <v-sheet
      tile
      height="54"
      class="d-flex align-center"
      style="margin-top: 3px"
    >
      <v-btn
        icon
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <div class="font-weight-medium flex-grow-1 text-center">
        {{ parseDate(weekStart.date) }} - {{ parseDate(weekEnd.date) }}
      </div>
      <v-btn
        icon
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-calendar
      class="d-none"
      ref="calendar"
      v-model="value"
      :weekdays="weekday"
      type="week"
      event-overlap-mode="stack"
      :event-overlap-threshold="30"
      @change="getEvents"
      :locale="getLocale()"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    weekday: [1, 2, 3, 4, 5, 6, 0],
    value: "",
    weekStart: "",
    weekEnd: ""
  }),
  methods: {
    getEvents({ start, end }) {
      this.weekStart = start;
      this.weekEnd = end;
      this.$emit("weekChange", { start: start.date, end: end.date });
    },
    parseDate(date) {
      return new Date(date).toLocaleString(this.getLocale(), {
        month: "long",
        day: "numeric"
      });
    }
  },
  computed: {
    year: function() {
      if (this.weekStart.year != this.weekEnd.year) {
        return `${this.weekStart.year} - ${this.weekEnd.year}`;
      } else {
        return this.weekStart.year;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.year {
  font-size: 14px;
  font-weight: 500;
  color: #407ec9;
  line-height: 1;
}
.weekly {
  font-size: 34px;
  font-weight: 500;
  color: #407ec9;
  line-height: 1;
}
</style>
